const siteId = process.env.REACT_APP_BUILD_SITE;

export const isPortalWithPropertySubType = ['ZPAR', 'IWBR', 'WIBR'].includes(siteId);
